<template>
  <div class="container is-fluid">
    <div class="columns">

        <div class="column">
          <p class="title is-1" align="center">Avatar</p>
          <p v-if="!hasAvatar2" class="title is-6" align="center">Please begin by creating a new avatar</p>

          <div class="columns">

            <div class="column is-one-third">
            </div>

            <div class="column is-one-third">
              <div class="imageplace">
                <didimoModal></didimoModal>
              </div>
            </div>

            <div class="column is-one-third">
              <!-- Create Avatar -->
              <p class="title is-3" align="center">Create New Avatar</p>
              <button id="createAvatarButton" @click="showCreateNewAvatarModal=true" class="button is-fullwidth is-medium is-centered">Create Avatar</button><br><br>
              <!-- Points balance -->
              <p class="title is-5" align="center">Upgrade Your Avatar</p>
              <p class="title is-3" align="center">Available points: {{ user.points }}</p>
              <!-- Marketplace Button -->
              <button class="button is-medium is-fullwidth" @click="goToMarketplacePage">Marketplace</button>
            </div>
          </div>
        </div>
    </div>
    <createNewAvatarModal v-show="showCreateNewAvatarModal" @close="showCreateNewAvatarModal = false" @closeCreateNewAvatarModal="closeCreateNewAvatarModal($event);"></createNewAvatarModal>
  </div>
</template>

<script>
import VueLocalStorage from 'vue-localstorage'
import didimoModal from './didimoModal.vue'
import * as firebase from 'firebase'
import createNewAvatarModal from './createNewAvatarModal.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showCreateNewAvatarModal: false,
      hasAvatar2: this.$store.getters.avatar.hasAvatar
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    closeCreateNewAvatarModal(bool) {
      var self = this
      if (bool == true) {
        self.$emit('close')
      }
    },
    goToMarketplacePage() {
      this.$router.push({path: '/market'})
    }
  },
  components: {
    didimoModal: didimoModal,
    createNewAvatarModal: createNewAvatarModal,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imageplace {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar/Avatar.vue